import { Toast } from 'react-bootstrap'
import styled from 'styled-components'

interface IStyledToastProps {
  type?: string
}

export const StyledToast = styled(Toast)<IStyledToastProps>`
  ${({ type }) =>
    type === 'error'
      ? 'background-color: #dc3545;'
      : type === 'warning'
      ? 'background-color: #f90;'
      : 'background-color: #28a745;'}

  top: 0;
  right: 0;
  padding: 1rem;
  position: fixed;
  z-index: 999999;
  width: 350px;
  display: flex;
  color: #fff;
  margin: 2rem;
  display: flex !important;

  * {
    font-size: 14px;
  }

  button {
    background: transparent;
    border: 0;
    padding: 0 8px;
    cursor: pointer;
    color: #fff;
  }
  .toast-body {
    width: 320px;
  }
`
